/**
 * used to send all ajax to afp
 * @param string section
 * @param objecvt data
 * @returns string
 */
function afpSendCoreAjax( section, data, disableAnimation ) {
    if( !disableAnimation ) {
        jQuery( '#afp-core-ajax-loading' ).show();
    }
	
    dataSent = new FormData();
    dataSent.append( 'action', 'afp_core_ajax' );
    dataSent.append( 'section', section );
    jQuery.each( data, function ( index, value ) {
        dataSent.append( index, value );
    } );
	
    if( typeof files !== 'undefined' && files.length > 0 ) {
        jQuery.each( files, function( key, value ) {
            console.log( files );
            dataSent.append( key, value );
        } );
    }
	
    var result = jQuery.ajax( {
        url: afp_front_ajax.ajaxurl,
        method: "POST",
        data: dataSent,
        cache: false,
        contentType: false,
        processData: false
    } );
	
    return result;
}